import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IOrganization, IOrganizationReducer, IOrganizationResponse, ITeamData} from '../../utils/types';

export const pendingOperation = (state: IOrganizationReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationReducer) => {
	state.isLoading = false;
};

export const organizationSignupOperation = (state: IOrganizationReducer, {payload}: PayloadAction<IOrganization>) => {
	state.organization = payload;
	state.isLoading = false;
};

export const organizationLoginOperation = (
	state: IOrganizationReducer,
	{payload}: PayloadAction<IOrganizationResponse>
) => {
	if ('organization' in payload) {
		state.organization = payload.organization;
		state.isLoading = false;
	}

	if ('team' in payload) {
		state.team = payload.team;
		state.isLoading = false;
	}
};

export const organizationLogoutOperation = (state: IOrganizationReducer) => {
	state.organization = null;
	state.isLoading = false;
};

export const getOrganizationInfoOperation = (state: IOrganizationReducer, {payload}: PayloadAction<IOrganization>) => {
	state.organization = payload;
	state.isLoading = false;
};

export const updateOrganizationInfoOperation = (
	state: IOrganizationReducer,
	{payload}: PayloadAction<IOrganization>
) => {
	state.organization = payload;
	state.isLoading = false;
};

export const getTeamMemberInfoOperation = (state: IOrganizationReducer, {payload}: PayloadAction<ITeamData>) => {
	state.team = payload;
	state.isLoading = false;
};
